import { FormGroup, FormSection, List } from '@ksyos/design-system';
import type { OsasTreatmentData } from '@common/validation/customControls/osas/osasTreatmentChoice/types';
import { FormParagraphFormGroup } from '@frontend/components/fields/FormParagraphField';

export function ReferRead(props: { refer?: OsasTreatmentData['refer'] }) {
    const { refer } = props;
    if (!refer) {
        return null;
    }

    return (
        <>
            <FormSection
                isBorderless={true}
                title="Doorverwijzen aan"
            >
                <FormParagraphFormGroup label="Zorginstelling">{refer.organization}</FormParagraphFormGroup>
                <FormParagraphFormGroup label="Afdeling">{refer.department}</FormParagraphFormGroup>
                <FormParagraphFormGroup label="Specialist, naam">{refer.specialismName}</FormParagraphFormGroup>
            </FormSection>
            <FormSection
                isBorderless={true}
                title="Aanvraag"
            >
                <FormParagraphFormGroup label="Aanvraag voor (onderwerp)">{refer.subject}</FormParagraphFormGroup>
                <FormParagraphFormGroup label="Bericht aan behandelaar">{refer.message}</FormParagraphFormGroup>
                <FormParagraphFormGroup label="Reden doorverwijzing">{refer.reason}</FormParagraphFormGroup>
            </FormSection>
            <FormSection
                isBorderless={true}
                title="Patiënt informatie"
            >
                <FormGroup label="Bijgevoegde informatie">
                    <List
                        size="small"
                        styleType="bullet"
                    >
                        <List.Item>Professionele samenvatting</List.Item>
                        <List.Item>Aanvullende specialistische bevindingen</List.Item>
                        <List.Item>Patiënten vragenlijsten scores</List.Item>
                        <List.Item>Uitslag slaaponderzoek</List.Item>
                        <List.Item>Beleid</List.Item>
                    </List>
                </FormGroup>
            </FormSection>
            <FormSection
                isBorderless={true}
                title="Conclusie"
            >
                <FormParagraphFormGroup label="Conclusie onderbouwing">{refer.conclusion}</FormParagraphFormGroup>
                <FormParagraphFormGroup label="Verwijsvraag">{refer.question}</FormParagraphFormGroup>
            </FormSection>
        </>
    );
}
